import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { getDataProtectionExclusionTypeGridValues } from '../../../../../utils/uiSettings/contentControl/content-control.values';
import { html, TemplateResult } from 'lit';
import { ContentControlDataProtectionExclusion } from '@nirvana/shared/dtos/types/policies/common';

export enum Column {
  ADDRESS = 1,
  TYPE,
  RULES_TO_CONSIDER,
}

export enum ColumnKeys {
  ADDRESS = 'address',
  TYPE = 'type',
  RULES_TO_CONSIDER = 'rulesToConsiderString',
}

export const GRID_COLUMNS = [Column.ADDRESS, Column.TYPE, Column.RULES_TO_CONSIDER];

export const FILTERS = [
  { [ColumnKeys.ADDRESS]: { contains: '' } },
  { [ColumnKeys.TYPE]: { in: [] } },
  { [ColumnKeys.RULES_TO_CONSIDER]: { contains: '' } },
];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.ADDRESS, ColumnKeys.TYPE, ColumnKeys.RULES_TO_CONSIDER];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.ADDRESS,
      key: ColumnKeys.ADDRESS,
      columnName: translateFn('Website or email address'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.ENUM,
      values: getDataProtectionExclusionTypeGridValues(),
      removable: false,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.RULES_TO_CONSIDER,
      key: ColumnKeys.RULES_TO_CONSIDER,
      columnName: translateFn('Rules'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
    },
  ];
}

export function addressCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ContentControlDataProtectionExclusion }
): TemplateResult {
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${rowData.item.address}</span
  >`;
}
